// import { config } from "./email-templates/";

const CoreModules = [];

export default CoreModules;
